export default "__VITE_ASSET__CNT3Mmzo__"